<ng-container *ngIf="isLoading else pageContent">
	<div class="app-spinner">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>

<ng-template #pageContent>

<ng-container *ngIf="!isAICreationRoute">
  <div class="container-fluid bg-color p-0 mb-1">
    <div class="row">
      <div class="classroom-header-card position-relative">
        <img [src]="_classroom.cover_image_url" class="cover-image" alt="Cover Image" />
        <div class="header-overlay"></div>
        <div class="header-content d-flex justify-content-between align-items-start px-4 pt-4">
          <div class="left-header text-white">
            <div class="d-flex align-items-center">
              <i class="bi bi-arrow-left-short back-arrow pr-5 ms-1"
                [routerLink]="['/teacher-dashboard/classroom']"></i>
              <h2 class="class-title">{{ _classroom.name || "N/A" }}</h2>
            </div>
            <p class="class-subject">{{ _classroom.subject || "N/A" }}</p>
            <div class="students-badge">
              <mat-icon class="text-white">groups</mat-icon>
              <span>{{ _classroom.student_count || 0 }} Students</span>
            </div>
          </div>

          <div class="right-header text-white text-end">
            <p class="invite-label mb-1">Invite Code</p>
            <div class="invite-code-box d-inline-flex align-items-center gap-2">
              <span>{{ _classroom.class_code || "N/A" }}</span>
              <mat-icon class="copy-icon" matTooltip="Copy code" (click)="copyText()">content_copy</mat-icon>
            </div>
          </div>
        </div>
      </div>

      <app-classroom-navbar></app-classroom-navbar>
    </div>
  </div>
</ng-container>

<router-outlet></router-outlet>
</ng-template>